module.exports = __webpack_public_path__ + "static/media/VC.c2b830ab.png";